import useSWR from "swr";
import { axiosConToken } from "../helpers/axios";
import {
  messageLoading,
  messageSuccessLoading,
  validaMessagesErrors,
} from "../helpers";
import { types } from "../types/typesAuth";
import { PATH_SEGURIDAD } from "../constants/routes";

// #region CRUD Usuario
export const usuariosStartLoad = () => {
  return async (dispatch) => {
    dispatch(authStatusLoading());
    try {
      const resp = await axiosConToken.get(PATH_SEGURIDAD.usuarios);
      const data = resp.data;
      dispatch(usuariosLoaded(data));
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(authStatusLoading(false));
    }
  };
};
export const usuarioStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(PATH_SEGURIDAD.usuarios, data);
      const { msg, usuario } = resp.data;
      dispatch(usuarioAdded(usuario));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const usuarioStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.patch(
        `${PATH_SEGURIDAD.usuarios}${data.id}/`,
        data
      );
      const { msg, usuario } = resp.data;
      dispatch(usuarioUpdated(usuario));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
export const usuarioStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_SEGURIDAD.usuarios}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(usuarioDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const usuariosLoaded = (usuarios) => ({
  type: types.authUsuariosLoaded,
  payload: usuarios,
});
const usuarioAdded = (usuario) => ({
  type: types.authUsuarioAdded,
  payload: usuario,
});
const usuarioUpdated = (usuario) => ({
  type: types.authUsuarioUpdated,
  payload: usuario,
});
const usuarioDeleted = (usuario) => ({
  type: types.authUsuarioDeleted,
  payload: usuario,
});
export const usuarioSetActive = (usuario) => ({
  type: types.authUsuarioSetActive,
  payload: usuario,
});
export const usuarioClearActive = () => ({
  type: types.authUsuarioClearActive,
});
export const usuarioShowForm = (visible = true) => ({
  type: types.authUsuarioShowForm,
  payload: visible,
});
export const authStatusLoading = (loading = true) => ({
  type: types.authStatusLoading,
  payload: loading,
});
// #endregion CRUD Usuario
// #region CRUD Modulo
const modulosStartLoad = () => {
  return async (dispatch) => {
    dispatch(authStatusLoading());
    try {
      const resp = await axiosConToken.get(PATH_SEGURIDAD.modulos);
      const data = resp.data;
      dispatch(modulosLoaded(data));
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(authStatusLoading(false));
    }
  };
};
const moduloStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(PATH_SEGURIDAD.modulos, data);
      const { msg, modulo } = resp.data;
      dispatch(moduloAdded(modulo));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const moduloStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_SEGURIDAD.modulos}${data.id}/`,
        data
      );
      const { msg, modulo } = resp.data;
      dispatch(moduloUpdated(modulo));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const moduloStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_SEGURIDAD.modulos}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(moduloDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const modulosLoaded = (modulos) => ({
  type: types.authModulosLoaded,
  payload: modulos,
});
const moduloAdded = (modulo) => ({
  type: types.authModuloAdded,
  payload: modulo,
});
const moduloUpdated = (modulo) => ({
  type: types.authModuloUpdated,
  payload: modulo,
});
const moduloDeleted = (modulo) => ({
  type: types.authModuloDeleted,
  payload: modulo,
});
const moduloSetActive = (modulo) => ({
  type: types.authModuloSetActive,
  payload: modulo,
});
const moduloClearActive = () => ({
  type: types.authModuloClearActive,
});

const rutaSetActive = (ruta) => ({
  type: types.authRutaSetActive,
  payload: ruta,
});
const rutaClearActive = () => ({
  type: types.authRutaClearActive,
});
const get_rutas = async () => {
  try {
    const resp = await axiosConToken.get(`${PATH_SEGURIDAD.modulos}get_rutas/`);
    return resp.data;
  } catch (error) {
    validaMessagesErrors(error);
  }
};
const rutaJsonStartUpload = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Cargando los datos...");
    try {
      const resp = await axiosConToken.post(
        `${PATH_SEGURIDAD.rutas}upload_rutas_by_json/`,
        data,
        { headers: { "content-type": "multipart/form-data" } }
      );
      const { msg, modulo } = resp.data;
      dispatch(moduloUpdated(modulo));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const SWR_get_rutas = () => {
  const { data, error } = useSWR(`${PATH_SEGURIDAD.modulos}get_rutas/`);

  return {
    data: data,
    isLoading: !data && !error,
    isError: error,
  };
};

// #endregion CRUD Modulo
// #region CRUD Ruta
const rutaStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(PATH_SEGURIDAD.rutas, data);
      const { msg, ruta, modulo } = resp.data;
      dispatch(rutaAdded(ruta));
      dispatch(moduloUpdated(modulo));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const rutaStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_SEGURIDAD.rutas}${data.id}/`,
        data
      );
      const { msg, ruta, modulo } = resp.data;
      dispatch(rutaUpdated(ruta));
      dispatch(moduloUpdated(modulo));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const rutaStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_SEGURIDAD.rutas}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(rutaDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const rutaAdded = (ruta) => ({
  type: types.authRutaAdded,
  payload: ruta,
});
const rutaUpdated = (ruta) => ({
  type: types.authRutaUpdated,
  payload: ruta,
});
const rutaDeleted = (ruta) => ({
  type: types.authRutaDeleted,
  payload: ruta,
});
const rutasModuloSetActive = (rutasModulo) => ({
  type: types.authRutasModuloSetActive,
  payload: rutasModulo,
});
const rutasModuloClearActive = () => ({
  type: types.authRutasModuloClearActive,
});
// #endregion

// #region CRUD Perfiles
const perfilesStartLoad = () => {
  return async (dispatch) => {
    dispatch(authStatusLoading());
    try {
      const resp = await axiosConToken.get(PATH_SEGURIDAD.perfiles);
      const data = resp.data;
      dispatch(perfilesLoaded(data));
    } catch (error) {
      validaMessagesErrors(error);
    } finally {
      dispatch(authStatusLoading(false));
    }
  };
};
const perfilStartAdd = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.post(PATH_SEGURIDAD.perfiles, data);
      const { msg, perfil } = resp.data;
      dispatch(perfilAdded(perfil));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const perfilStartUpdate = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.put(
        `${PATH_SEGURIDAD.perfiles}${data.id}/`,
        data
      );
      const { msg, perfil } = resp.data;
      dispatch(perfilUpdated(perfil));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const perfilStartDelete = (data) => {
  return async (dispatch) => {
    const msgload = messageLoading("Guardando...");
    try {
      const resp = await axiosConToken.delete(
        `${PATH_SEGURIDAD.perfiles}${data.id}/`
      );
      const { msg } = resp.data;
      dispatch(perfilDeleted(data));
      messageSuccessLoading(msgload, msg);
    } catch (error) {
      validaMessagesErrors(error, msgload);
    }
  };
};
const perfilesLoaded = (perfiles) => ({
  type: types.authPerfilesLoaded,
  payload: perfiles,
});
const perfilAdded = (perfil) => ({
  type: types.authPerfilAdded,
  payload: perfil,
});
const perfilUpdated = (perfil) => ({
  type: types.authPerfilUpdated,
  payload: perfil,
});
const perfilDeleted = (perfil) => ({
  type: types.authPerfilDeleted,
  payload: perfil,
});
const perfilSetActive = (perfil) => ({
  type: types.authPerfilSetActive,
  payload: perfil,
});
const perfilClearActive = () => ({
  type: types.authPerfilClearActive,
});

// #endregion

export {
  modulosStartLoad,
  moduloStartAdd,
  moduloStartUpdate,
  moduloUpdated,
  moduloStartDelete,
  moduloSetActive,
  moduloClearActive,
  rutaSetActive,
  rutaClearActive,
  rutaStartAdd,
  rutaStartUpdate,
  rutaStartDelete,
  rutasModuloSetActive,
  rutasModuloClearActive,
  perfilesStartLoad,
  perfilStartAdd,
  perfilStartUpdate,
  perfilStartDelete,
  perfilSetActive,
  perfilClearActive,
  get_rutas,
  SWR_get_rutas,
  rutaJsonStartUpload,
};
